import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="py-24 bg-offwhite" data-id="element-13">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-15">
          <div className="md:col-span-4" data-id="element-16">
            <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-17">
              Executive Profile
            </h2>
            <div className="w-16 h-px bg-gold mb-8" data-id="element-18"></div>
          </div>

          <div className="md:col-span-8" data-id="element-19">
            <div className="prose prose-lg text-navy-light max-w-none" data-id="element-20">
              <p className="mb-6" data-id="element-21">
                With 40 years of senior executive industrial experience, I have
                held in-country leadership roles across Europe, Asia, and the
                USA. My career is defined by a deep understanding of varied
                market and regulatory environments, driving cross-cultural
                leadership and strategic growth.
              </p>
              <p className="mb-8" data-id="element-22">
                My extensive M&A experience spans Europe, the Americas, the
                Middle East, Africa, and the Asia/Pacific regions, enabling me
                to provide robust oversight and strategic guidance to boards
                navigating complex global landscapes and the ongoing energy
                transition.
              </p>

              <div className="flex flex-wrap gap-4 mt-10" data-id="element-23">
                {['BSc (Hons)', 'PhD', 'CEng', 'FIMMM'].map(credential => <span key={credential} className="px-4 py-2 border border-gold/30 text-navy text-sm font-medium tracking-wide" data-id="element-24">
                    {credential}
                  </span>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}